import classNames from 'classnames'
import React from 'react'

const StatusBar = ({
  currentStep,
  steps = [
    { id: 1, label: 'Zakładanie konta' },
    { id: 2, label: 'Aktywacja konta' },
    { id: 3, label: 'Konto aktywne' }
  ],
  setCurrentStep,
  localStorageKey
}: {
  currentStep: number
  steps?: { id: number; label: string }[]
  setCurrentStep?: (value: React.SetStateAction<number>) => void
  localStorageKey?: string
}) => {
  return (
    <div className="flex flex-col sm:flex-row items-center sm:w-1/2">
      {steps.map((step, index) => (
        <div
          key={step.id}
          className={classNames(
            'flex items-center',
            'sm:mb-0 mb-6',
            'sm:flex-row flex-col'
          )}
        >
          {/* Circle */}
          <div
            className={classNames(
              'w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-full border-2',
              currentStep >= step.id
                ? 'bg-blue-500 border-blue-500 text-white hover:bg-blue-600 hover:border-blue-600'
                : 'bg-gray-100 border-gray-300 text-gray-500',
              setCurrentStep ? 'cursor-pointer' : 'cursor-default'
            )}
            onClick={
              setCurrentStep
                ? () => {
                    currentStep > step.id && localStorageKey
                      ? localStorage.setItem(
                          localStorageKey,
                          step.id.toString()
                        )
                      : null
                    currentStep > step.id ? setCurrentStep(step.id) : null
                  }
                : () => null
            }
          >
            {step.id}
          </div>

          {/* Label / Step Name */}
          <span
            className={classNames(
              'mt-2 sm:mt-0 sm:ml-2 px-2 text-sm',
              currentStep >= step.id ? 'text-blue-600' : 'text-gray-500'
            )}
          >
            {step.label}
          </span>

          {/* Connector Line (hidden on mobile) */}
          {index < steps.length - 1 && (
            <div
              className={classNames(
                'w-12 h-1 sm:block hidden',
                currentStep > step.id ? 'bg-blue-500' : 'bg-gray-300'
              )}
            />
          )}
        </div>
      ))}
    </div>
  )
}

export default StatusBar
